import { useAlterStatusInventory } from '@/core/domain/inventory/inventories/inventory.hooks';
import {
  Inventory,
  InventoryStatus,
  ProductTypeLabels,
} from '@/core/domain/inventory/inventories/Inventory.types';
import { useDisclosure } from '@/hooks';

import { Button, Checkbox, Modal } from 'antd';
import { useCallback, useState } from 'react';

interface Props {
  inventory: Inventory;
}

const ImportAllItemsInventoryModal = ({ inventory }: Props) => {
  const alterStatusInventory = useAlterStatusInventory();

  const [populateOnlyWithStock, setPopulateOnlyWithStock] = useState(false);

  const [opened, action] = useDisclosure(false, {
    onClose: () => setPopulateOnlyWithStock(false),
  });

  const importInventory = useCallback(async () => {
    try {
      await alterStatusInventory.mutateAsync({
        id: inventory.id,
        status: inventory.status,
        populateInventory: true,
        populateOnlyWithStock,
      });
      action.close();
    } catch {}
  }, [inventory, populateOnlyWithStock]);

  const title = `Importar ${ProductTypeLabels[inventory.productType].all} ${
    ProductTypeLabels[inventory.productType].lowercase
  } da base no inventário`;

  const btnText = `Importar  ${ProductTypeLabels[inventory.productType].all} ${
    ProductTypeLabels[inventory.productType].lowercase
  } para o inventário`;

  return (
    <>
      <Button
        type="primary"
        onClick={action.open}
        disabled={
          inventory?.status === InventoryStatus.DONE ||
          inventory?.status === InventoryStatus.PROCESSING ||
          inventory?.status === InventoryStatus.IMPORTING
        }
      >
        {btnText}
      </Button>

      <Modal
        title={title}
        okText="Importar"
        open={opened}
        onOk={importInventory}
        onCancel={action.close}
        cancelButtonProps={{ disabled: alterStatusInventory.isLoading }}
        confirmLoading={alterStatusInventory.isLoading}
      >
        <>
          <p>
            {`Caso a quantidade de ${
              ProductTypeLabels[inventory.productType].lowercase
            } do inventário
            seja muito grande, a importação será processada durante a noite e o
            inventário estará disponível apenas no dia seguinte.`}
          </p>

          <Checkbox
            checked={populateOnlyWithStock}
            onChange={(event) => setPopulateOnlyWithStock(event.target.checked)}
          >
            Importar todas as peças apenas com estoque maior que zero
          </Checkbox>
        </>
      </Modal>
    </>
  );
};

export default ImportAllItemsInventoryModal;
